import * as React from "react";
import { runHattrickOn } from "../../../API/hattrick";
import { useUserContext } from "../../../contexts/ProviderProvider";
import {
    Table,
    TableContainer,
    Typography,
    Paper,
    TableCell,
    TableRow,
    TableBody,
    TableHead,
    Button,
} from "@mui/material";
import useNotification from "../../../hooks/useNotification";
import { useNavigate } from "react-router";

const HattrickTeamCollectionReadyTable = ({ data, refresh, currentlyRunning }) => {
    const user = useUserContext();
    const notify = useNotification();
    const navigate = useNavigate();

    if (!data) {
        return <Typography>No Team Collections to create!!</Typography>;
    }

    const runHattrickOnCollection = async (collectionId, teamId) => {
        try {
            const response = await runHattrickOn(
                {
                    team_running: [{ type_id: collectionId, team_id: teamId }],
                    type: "team collections",
                },
                user
            )

            console.log('response from running team collections: ', response)
        } catch (error) {
            console.error('error while running hattrick on team collection ', error)
            notify("Failed to start hattrick on team collection");
        } finally {
            refresh();
        }
    };

    const isRunning = (row) => {
        return currentlyRunning.filter((cr) => cr.type_id === row.CollectionId).length > 0
    };

    return (
        <div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Team Id</TableCell>
                            <TableCell>Shopify Collection Id</TableCell>
                            <TableCell>University</TableCell>
                            <TableCell>Sport</TableCell>
                            <TableCell>State</TableCell>
                            <TableCell>Photo</TableCell>
                            <TableCell>Run</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row) => (
                            <TableRow
                                key={row.TeamId}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                                <TableCell>{row.TeamId}</TableCell>
                                <TableCell>{row.ShopifyCollectionId}</TableCell>
                                <TableCell>{row.University}</TableCell>
                                <TableCell>{row.Sport}</TableCell>
                                <TableCell>{row.State}</TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ padding: "25px" }}
                                >
                                    <img
                                        alt={"prooduct asset"}
                                        style={{ maxHeight: "100px" }}
                                        src={row.Photo}
                                        onClick={() => {
                                            window.open(row.photo, "_blank");
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Button
                                        disabled={isRunning(row)}
                                        variant="contained"
                                        onClick={() =>
                                            runHattrickOnCollection(row.CollectionId, row.TeamId)
                                        }
                                    >
                                        Run
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default HattrickTeamCollectionReadyTable;
